import Interweave from "interweave";
import React from "react";
import { getTermsAndConditions, getPrivacyPolicy } from "../../APIs/GetAPIs";
import { Images } from "../../Assets/0a-exporter";
import CommonFooter from "../LandingPage/CommonFooter/CommonFooter";
import LandingHeader from "../LandingPage/LandingHeader/LandingHeader";
import "./terms-and-condition.style.scss";
export default function TermsAndConditions({pp}) {
  const [content, setContent] = React.useState(null);
  const setUpContent = async () => {
    let res;
    if(pp){
        res = await getPrivacyPolicy();

    }else{
        res = await getTermsAndConditions();

    }
    if (res.data.statusCode === 200) {
      setContent(res.data?.data?.[0]?.data, "");
    } else {
    }
  };
  React.useEffect(() => {
    setUpContent();
  }, []);
  return (
    <div className="terms-and-condition-main">
      <LandingHeader opaque="opaque" help={true} />
      <div className="tacm-title-section">
        <img src={Images.dotsGrayBottomLeft} />
        <img src={Images.dotsGrayTopRight} />
        <h4>{pp ? titles.pp.title : titles.tc.title}</h4>
        <p>{pp ? titles.pp.extra : titles.tc.extra}</p>
      </div>
      <section className="tacm-body-section">
        {content ? <Interweave content={content} /> : ""}
      </section>
      <CommonFooter />
    </div>
  );
}
const titles = {
  tc: {
    title: "Terms and Conditions",
    extra:
      "These Terms, read with the Policy, form the complete and final contract between the User and the Company with respect to the subject matter hereof and supersedes all other communications.",
  },
  pp: {
    title: "Privacy Policy",
    extra:
      "The creator of this Privacy Policy ensures steady commitment to Your privacy with regard to the protection of your invaluable information.",
  },
};
